import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useAuth } from './AuthContext';

const HelpContext = createContext();
export const useHelp = () => useContext(HelpContext);

const TOUR_DONE_KEY = 'help-tour-completed';

export function HelpProvider({ children }) {
  const { user } = useAuth();
  // mode: 'welcome' = full intro (auto on first login), 'page' = current page tour
  const [tour, setTour] = useState({ open: false, mode: 'welcome' });

  const openTour = useCallback((mode = 'page') => {
    setTour({ open: true, mode });
  }, []);

  const closeTour = useCallback(() => {
    setTour(t => ({ ...t, open: false }));
    try { localStorage.setItem(TOUR_DONE_KEY, '1'); } catch {}
  }, []);

  // Auto-open the welcome tour on first login (per browser)
  useEffect(() => {
    if (!user) return;
    let done = '0';
    try { done = localStorage.getItem(TOUR_DONE_KEY) || '0'; } catch {}
    if (done !== '1') {
      const t = setTimeout(() => setTour({ open: true, mode: 'welcome' }), 600);
      return () => clearTimeout(t);
    }
  }, [user]);

  return (
    <HelpContext.Provider value={{
      tourOpen: tour.open,
      tourMode: tour.mode,
      openTour,
      closeTour,
    }}>
      {children}
    </HelpContext.Provider>
  );
}
